import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Drivers from "./pages/Drivers";
import DriverProfile from "./pages/DriverProfile";
import { supabase } from "./supabase";
import { useState, useEffect } from "react";
import Analytics from "./pages/Analytics";
import Team from "./pages/Team";
import Settings from "./pages/Settings";
import Settlements from "./pages/Settlements";
import Loads from "./pages/Loads";
import FuelTolls from "./pages/FuelTolls";
import Alerts from "./pages/Alerts";
import Vehicles from "./pages/Vehicles";
import Maintenance from "./pages/Maintenance";

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
  }, []);

  if (loading)
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-500">Loading...</div>
      </div>
    );

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={!session ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/"
          element={session ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route
          path="/drivers"
          element={session ? <Drivers /> : <Navigate to="/login" />}
        />
        <Route
          path="/drivers/:id"
          element={session ? <DriverProfile /> : <Navigate to="/login" />}
        />
        <Route
          path="/analytics"
          element={session ? <Analytics /> : <Navigate to="/login" />}
        />
        <Route
          path="/team"
          element={session ? <Team /> : <Navigate to="/login" />}
        />
        <Route
          path="/settings"
          element={session ? <Settings /> : <Navigate to="/login" />}
        />
        <Route path="/settlements" element={<Settlements />} />
        <Route path="/loads" element={<Loads />} />
        <Route path="/fuel-tolls" element={<FuelTolls />} />
        <Route
          path="/alerts"
          element={session ? <Alerts /> : <Navigate to="/login" />}
        />
        <Route
          path="/vehicles"
          element={session ? <Vehicles /> : <Navigate to="/login" />}
        />
        <Route
          path="/maintenance"
          element={session ? <Maintenance /> : <Navigate to="/login" />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
